import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '@/redux';
import { LoggerService } from '@/services';
import { useServices } from '@/services/useServices';
import { round } from '@/utils/millesimaUtils';
import { getOnePhoneNumberFromCart } from '@/utils/addressUtils';

import { loadPaymentProvider } from '@/redux/thunks/checkout/loadPaymentProvider';
import { LOG_MSG, LOG_URL } from '@/constants/logger';
import { PAYMENT_PLATFORMS } from '@/constants/checkout';

export const PayjunctionForm = () => {
  const dispatch = useAppDispatch();
  const storeConf = useAppSelector(({ root }) => root.storeConf);
  const cart = useAppSelector(({ cart }) => cart.content);
  const user = useAppSelector(({ user }) => user.content);

  const PAYJUNCTION_URL = process.env.NEXT_PUBLIC_PAYJUNCTION_URL || process.env.NEXT_PUBLIC_DEFAULT_HOST + '/payjunction';

  const { authService: { authToken } } = useServices();

  const { paiementMode, total, billing, shipping } = cart;
  const userId = user?._id || LOG_MSG.MISSING.USER;
  const cartId = cart?.id || LOG_MSG.MISSING.CART;
  const storeId = storeConf?.storeId || LOG_MSG.MISSING.STORE;

  useEffect(() => {
    dispatch(loadPaymentProvider({ paymentProvider: PAYMENT_PLATFORMS.PAY_JUNCTION }));
    LoggerService.sendLog(cartId, LOG_MSG.PAYJUNCTION.FORM, storeId, LOG_URL.PAYJUNCTION_FORM, userId, cart);
  }, []);

  return (
    <form method="post" name="PayJunctionForm"
      action={`${paiementMode?.payjunctionBaseUrl}trinity/quickshop/add_to_cart_snap.action`} id="payjunction-form" >
      <input type="hidden" name="store" value={paiementMode?.payjunctionStore} />
      <input type="hidden" name="need_to_ship" value="no" />
      <input type="hidden" name="need_to_tax" value="no" />
      <input type="hidden" name="quantity" value="1" />
      <input type="hidden" name="description" value={`Web Order ${cartId} from millesima-usa.com`} />
      <input type="hidden" name="price" id="payJunctionPrice" value={round(total)} />
      <input type="hidden" name="relay" value={PAYJUNCTION_URL} />
      <input type="hidden" name="echo" value={`userToken=${authToken}&cartId=${cartId}`} />

      <input type="hidden" name="identifier" value={cartId} autoComplete="off" />
      <input type="hidden" name="invoice" value={cartId} autoComplete="off" />
      <input type="hidden" name="purchaseOrderNumber" value={cartId} autoComplete="off" />

      <input type="hidden" name="billingFirstName" value={billing?.firstName} autoComplete="off" />
      <input type="hidden" name="billingTitle" value={billing?.civility} autoComplete="off" />
      <input type="hidden" name="billingLastName" value={billing?.lastName} autoComplete="off" />
      <input type="hidden" name="billingPhone" value={getOnePhoneNumberFromCart(billing)} autoComplete="off" />
      <input type="hidden" name="billingEmail" value={user?.email} autoComplete="off" />
      <input type="hidden" name="billingCustomerId" value={userId} autoComplete="off" />
      <input type="hidden" name="billingStreetAddress" value={billing?.addressName} autoComplete="off" />
      <input type="hidden" name="billingCity" value={billing?.city} autoComplete="off" />
      <input type="hidden" name="billingZip" value={billing?.postalCode} autoComplete="off" />
      <input type="hidden" name="billingCountry" value={billing?.country} autoComplete="off" />

      <input type="hidden" name="shippingFirstName" value={shipping?.firstName} autoComplete="off" />
      <input type="hidden" name="shippingTitle" value={shipping?.civility} autoComplete="off" />
      <input type="hidden" name="shippingLastName" value={shipping?.lastName} autoComplete="off" />
      <input type="hidden" name="shippingPhone" value={getOnePhoneNumberFromCart(shipping)} autoComplete="off" />
      <input type="hidden" name="shippingEmail" value={user?.email} autoComplete="off" />
      <input type="hidden" name="shippingCustomerId" value={userId} autoComplete="off" />
      <input type="hidden" name="shippingStreetAddress" value={shipping?.addressName} autoComplete="off" />
      <input type="hidden" name="shippingCity" value={shipping?.city} autoComplete="off" />
      <input type="hidden" name="shippingZip" value={shipping?.postalCode} autoComplete="off" />
      <input type="hidden" name="shippingCountry" value={shipping?.country} autoComplete="off" />
    </form>
  );
};

export default PayjunctionForm;
